import React, { useEffect, useState } from "react";
//
import { useAsyncDebounce } from "react-table";
import { FormControl } from "../../../Form";

function TableSearch({
  config,

  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(
    config?.search?.searchValue || globalFilter
  );
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  useEffect(() => {


    if (globalFilter === undefined) {
      setValue("");
    } else setValue(globalFilter);
  }, [globalFilter]);

  return (
    <FormControl
      name="search"
      type="search"
      onChange={(e) => {
        const value = e.target.value;
        setValue(value);
        onChange(value);
        localStorage.setItem(
          config.nameSpace,
          JSON.stringify({ ...config, search: { searchValue: value } })
        );
      }}
      formStyle="default"
      style={{
        minHeight: "40px",
        minWidth: "250px",
        alignSelf: "flex-end",
        marginBottom: "9px",
        marginTop: "20px",
        marginRight: "11px",
      }}
      // inputButton={[]}
      value={value || ""}
      width="100%"
      label="Search"
      //   helperText={focused && 'Use a comma to separate keywords.'}
    />
  );
}

export default TableSearch;
